import { ShopSelectionWidget, RoleSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  shop_id: {
    'ui:widget': ShopSelectionWidget,
    'ui:options': {
      initFilter: {
        for_admin: 1,
      },
    },
  },
  role_id: {
    'ui:widget': RoleSelectionWidget,
  },
});

export default uiSchema;
